import Pagination from "../../../components/Pagination.vue";
import AIModelService from "../../../services/AIModel.service";
import SubscriptionService from "../../../services/Subscription.service";
import { alertResponseError, alertResponseSuccess } from "../../../helpers/general";
import * as Swal from "sweetalert2";

export default {
    components: {
        appPagination: Pagination
    },
    data() {
        return {
            pagination : {
                currentPage: 1,
                pageCount: 1,
            },
            arrModels: [],
            is_create_button_available: false,
            subscription: null,
      }
    },
    mounted() {
        this.check_subscription_status();
    },
    methods:{
        check_subscription_status() {
            SubscriptionService.getSubscription().then(() => {
                this.subscription = this.$store.getters.subscription;
                this.is_create_button_available = this.check_create_button_available();
            });
        },
        check_create_button_available() {
            if (this.subscription && this.subscription.ai_model_count_limit_enable) {
                // created ai model count < max ai model count
                if (this.subscription.usage_ai_model_count < this.subscription.ai_model_count) {
                    return true;
                } else {
                    return false;
                }
            // no subscription
            } else {
                return false;
            }
        },
        getAllModels() {
            AIModelService.getAllModels(this.pagination.currentPage).then((response) => {
                if (response.data.success) {
                    this.arrModels = response.data.data.results;
                    this.pagination.pageCount = response.data.data.count;
                }
            }).catch((error) => {
                alertResponseError(error.response.data);
            });
        },
        deleteAIModel(id) {
            Swal.fire({
                text: this.$t("ai_model.confirm_delete_model"),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ef8157',
                confirmButtonText: this.$t('common.yes'),
                cancelButtonText: this.$t('common.no'),
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    AIModelService.deleteAIModel(id).then((response) => {
                        if (response.data.success) {
                            alertResponseSuccess(this.$t("common_message.delete_success"));
                            this.getAllModels();
                            this.check_subscription_status();
                        }
                    }).catch((error) => {
                        alertResponseError(error);
                    });
                }
            });
        },
        buttonClicked(type, model) {
            // save model id and name to local
            localStorage.setItem('selected_ai_model', JSON.stringify({id: model.id, name: model.name}));
            this.$router.push({ name: type, params: { id: model.id } });
        }
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.getAllModels();
        // clear localStorage selected_ai_model
        localStorage.removeItem('selected_ai_model');
    }
}